import { render, staticRenderFns } from "./FrequentlyOrderList.vue?vue&type=template&id=23b663f6&scoped=true&"
import script from "./FrequentlyOrderList.vue?vue&type=script&lang=js&"
export * from "./FrequentlyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyOrderList.vue?vue&type=style&index=0&id=23b663f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b663f6",
  null
  
)

export default component.exports